import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-formly-repeat-editable-rating',
  imports: [FormlyModule, TranslateModule, MatButtonModule, MatIcon],
  templateUrl: './formly-repeat-editable.component.html',
  styleUrl: './formly-repeat-editable.component.scss',
})
export class FormlyRepeatEditableComponent extends FieldArrayType {
  constructor() {
    super();
  }
}
